<!-- 
  © 2025 Ananda Kumar. All rights reserved.
  Unauthorized copying of this file, via any medium, is strictly prohibited.
-->
<div *ngIf="isLoading$ | async" class="loading-overlay">
  <ng-lottie [options]="animationOptions" [styles]="{ width: '100px', height: '100px' }"></ng-lottie>
</div>